import { isEmpty } from 'lodash-es';
import { LOG_ACTIONS, logNewRelicAction } from '@namespace/analytics';
import { setCookie } from '@namespace/helpers';
import { getSegmentsList } from '../api/getSegmentsList';
import { AB_TEST_COOKIE } from '../constants';
import getABTest from '../utils/getABTest';
import getABTests from '../utils/getABTests';
import getABTestsFromCookie from '../utils/getABTestsFromCookie';
import { useABTestStore } from './store';

export const actionsCreator = ({ setState }) => ({
  INIT_AB_TESTS: (config) => {
    const prevABTests = getABTestsFromCookie();
    const { abTests, newTests } = getABTests(config, prevABTests);
    const allABTests = { ...window.AB_TESTS, ...abTests };
    window.AB_TESTS = allABTests;

    if (!isEmpty(abTests)) {
      setState({ abTests: allABTests });

      if (!isEmpty(newTests)) {
        logNewRelicAction(LOG_ACTIONS.INIT_AB_TEST, newTests, {
          sendAB: false
        });
      }

      try {
        setCookie(AB_TEST_COOKIE, JSON.stringify(allABTests), { expires: 365 });
      } catch (e) {
        console.warn(e);
      }
    }
  },
  ADD_AB_TEST: (newABTest) => {
    const prevABTests = getABTestsFromCookie();
    const abTest = getABTest(newABTest, prevABTests) || {};
    const allABTests = { ...window.AB_TESTS, ...abTest };
    window.AB_TESTS = allABTests;

    try {
      setCookie(AB_TEST_COOKIE, JSON.stringify(allABTests), { expires: 365 });
    } catch (e) {
      console.warn(e);
    }

    setState({ abTests: allABTests });

    return Object.values(abTest)[0];
  },
  FETCH_AB_SEGMENTS: async () => {
    const fetchedABSegments = await getSegmentsList();
    const abSegments = fetchedABSegments?.segments;

    setState({ abSegments, isSegmentsLoaded: true });

    return abSegments;
  },
  ADD_SEGMENTS_AB_TEST: (abTests) => {
    setState({ segmentsAbTests: abTests });
  }
});

export const abTestActions = actionsCreator(useABTestStore);
